export default __webpack_public_path__ + "static/media/eyesofset.2aa9c878.png";